import { createNestedObjectWithValues } from "../../../../helpers/historyHelpers/nestedObjectWithValues";
import { useVisible } from "../../../../../../utils/hooks/useVisible";
import RenderItem from "./RenderItem";
import HistoryTooltipComponent from "../../../../helpers/historyHelpers/components/HistoryTooltipComponent";

function HistoryTooltip({ row }) {
    const { visible, toggle } = useVisible();
    const id = `settings-history-${row.original.id}`;
    let keysLength = (row.original.action !== "create" && row.original.action !== "delete") ? Object.keys(row.original.data).length : 1;
    const formattedData = createNestedObjectWithValues(row.original.data || {});

    return (
        <HistoryTooltipComponent id={id} keysLength={keysLength} visible={visible} toggle={toggle} row={row}>
            <RenderItem data={formattedData} />
        </HistoryTooltipComponent>
    );
}

export default HistoryTooltip;
